<template>
  <form class="card-body" @submit.prevent="remindPassword()">
    <h2 class="card-login-title">Восстановление пароля</h2>

    <div class="form-group">
      <label for="input-login-email">E-mail адрес</label>
      <input
        id="input-login-email"
        type="email"
        class="form-control form-control-lg"
        placeholder="E-mail"
        v-model="auth.email"
        name="email"
        v-focus
        ref="input"
      >
    </div>

    <div class="form-actions">
      <button class="btn btn-primary btn-lg btn-block" type="submit">Продолжить</button>
      <button class="btn btn-link btn-block" @click="$emit('cancel')" type="button">Назад</button>
    </div>

    <div class="alert alert-danger" :class="{ 'new': error_new } " v-if="error">{{ error }}</div>
  </form>
</template>

<script>
  import auth from '../../auth'
  import api from '@/api'
  import { pick } from 'lodash'

  export default {
    props: ['email'],
    data () {
      return {
        auth: {
          email: this.email,
        },
        error: '',
        error_new: false,
      }
    },
    computed: {
      authData () {
        return this.auth
      },
    },
    methods: {
      remindPassword () {
        if (!this.auth.email) {
          this.$refs.input.focus()
          return
        }

        api.post('auth/remind', this.authData)
          .then(({data}) => {
            this.$emit('remindPassword', this.authData)
          })
          .catch((error) => {
            this.error = 'Пользователь не найден'
            this.error_new = true
            setTimeout(() => {
              this.error_new = false
            }, 100)
          })
      },
    },
  }
</script>

<style lang="scss"></style>



// WEBPACK FOOTER //
// resources/assets/js/components/login/remind.vue